import { Component, Optional } from '@angular/core';
import { Contact } from 'src/shared/api';
import { FormConfig, CustomFormAccessor } from '../form-cva.component';
import { NgControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { ContactDialogComponent } from './contact-dialog/contact-dialog.component';

export const EMPTY_CONTACT: Contact = {
	id: 0,
	firstName: '',
	lastName: '',
	role: '',
	phoneNumbers: [],
	emailAddresses: [],
};

export const contactFormConfig: FormConfig<Required<Contact>> = {
	id: [''],
	firstName: ['', [Validators.required]],
	lastName: ['', [Validators.required]],
	role: [''],
	phoneNumbers: [[]],
	emailAddresses: [[], [Validators.required]],
};

@Component({
	selector: 'rpshared-contact',
	templateUrl: './contact.component.html',
})
export class ContactComponent extends CustomFormAccessor<Contact> {
	constructor(
		public ngControl: NgControl,
		public fb: FormBuilder,
		@Optional() public dialog: MatDialogRef<ContactDialogComponent>
	) {
		super(ngControl, fb, contactFormConfig);
	}

	// model --> view
	writeValue(value: Contact): void {
		if (value) {
			this.form.setValue(value);
		}
	}

	// view --> model
	registerOnChange(fn: (value: Contact) => void) {
		this.form.valueChanges.pipe(takeUntil(this.destroyed)).subscribe(fn);
	}

	setDisabledState?(isDisabled: boolean) {
		if (isDisabled) {
			this.form.disable();
		} else {
			this.form.enable();
		}
	}
}
